import clsx from "clsx";

const Button = ({
  label,
  onClick,
  prefixIcon,
  suffixIcon,
  type = "button",
  className = null,
}) => {
  return (
    <button className={clsx("button", className)} type={type} onClick={onClick}>
      {prefixIcon ? (
        <img className="button__icon" src={prefixIcon} alt="" />
      ) : null}
      {label}
      {suffixIcon ? (
        <img className="button__icon" src={suffixIcon} alt="" />
      ) : null}
    </button>
  );
};

export default Button;
